import {apiClient} from '../../../../lib/api-client';
import {ReportResult} from '../../../../types/ReportResult';
import {MaterialCostReportParams} from '../types/MaterialCostReportParams';

export async function apiPrintMaterialCost(params: MaterialCostReportParams): Promise<ReportResult> {
    try {
        return await apiClient.get("report/material-cost",
            {
                params: params
            });
    } catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            data: ''
        };
    }
};
